import React from 'react';

const TYPE_LABELS = {
  text: 'Mensaje',
  image: 'Imagen',
  ptt: 'Audio',
  document: 'Documento',
};

const preview = wa => {
  if (wa.message_type === 'text') return wa.message_text || '';
  return wa.caption || TYPE_LABELS[wa.message_type] || 'Adjunto';
};

const UnmatchedWhatsappsList = ({ whatsapps, selectedId, onSelect }) => {
  return (
    <ul className='divide-y divide-slate-100'>
      {whatsapps.map(wa => (
        <li key={wa._id}>
          <button
            type='button'
            onClick={() => onSelect(wa)}
            className={`w-full text-left px-4 py-3 transition-colors ${
              selectedId === wa._id ? 'bg-green-50' : 'hover:bg-slate-50'
            }`}
          >
            <div className='flex items-center justify-between'>
              <p className='font-medium text-slate-800 truncate'>{wa.debtor_phone}</p>
              <span className='text-xs text-slate-400 flex-shrink-0 ml-2'>
                {wa.received_at ? new Date(wa.received_at).toLocaleDateString('es-ES') : ''}
              </span>
            </div>
            <p className='text-sm text-slate-500 truncate mt-0.5'>{preview(wa)}</p>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default UnmatchedWhatsappsList;
